module.exports = __webpack_public_path__ + "img/logo-neon-nieto-new.88e10510.jpg";